import { Component, Input, OnInit } from '@angular/core';
import { CellValueService } from '../cell-value.service';
import { ColumnDefinition } from '../../va-table-definition/va-table-definition';

@Component({
  selector: 'va-filter2-table-date-column',
  template: `
    <span [matTooltip]="value | date: 'mediumTime'" class="tooltip-anchor">
      {{ value | date: 'shortDate' }}
    </span>
  `,
  standalone: false,
})
export class DateColumnComponent<T> implements OnInit {
  @Input() columnDefinition: ColumnDefinition;

  @Input() element: T;

  value: any;

  constructor(private readonly cellValueService: CellValueService<T>) {}

  ngOnInit(): void {
    this.value = this.cellValueService.getCellValue(
      this.columnDefinition.id,
      this.columnDefinition.field,
      this.element,
    );
  }
}
